import angular from 'angular';
import moment from 'moment';

import uiRouter from 'angular-ui-router';
import  './components/loopback/lb-services.js';
import  'angular-resource';
import 'ocLazyLoad';
import 'angular-cached-resource';
import 'angular-file-upload';
import 'angular-vs-repeat';
import 'ui-select';
// import 'ng-table';
import 'angular-sanitize';
import 'angular-ui-scroll';
import 'angular-bootstrap';
import 'ng-iban';

import { injectNgDeps } from '../libs/ngDeps';

require('ngreact');

angular
  .module("AccountingBoxApp", [
    'lbServices',
    uiRouter,
    'ngResource',
    // 'ngTable',
    "oc.lazyLoad",
    "ngCachedResource",
    "angularFileUpload",
    "vs-repeat",
    "ui.select",
    "ngSanitize",
    "ui.scroll",
    'ui.bootstrap',
    "mm.iban",
    "react",
    // "ngSentry",
    // "config",
    // "ngAnimate",
    // "sticky",
    // "ra.sticktotop",
    // "ct.ui.router.extras.previous",

    // "angulartics",
    // "angulartics.google.analytics",
  ])
  .config(function(
    $stateProvider,
    $urlRouterProvider,
    $locationProvider,
    $httpProvider,
    $provide,

  ) {
    $urlRouterProvider.otherwise(function($injector, $location) {
      var $state = $injector.get("$state");
      $state.go("login");
    });
    $locationProvider.html5Mode(true);
    $locationProvider.hashPrefix('');
    $httpProvider.interceptors.push("authInterceptor");
    $httpProvider.interceptors.push("bookkeeperInterceptor");

    $provide.decorator("LoopBackResource", function(
      $delegate,
      $cachedResource,
      $resource
    ) {
      return function(url, params, actions) {
        var sUrl = url.replace(API_ENDPOINT, "");
        var object = sUrl.split("/")[1];
        var cacheKey = object;
        var o = object;
        if (object === "Accounts") {
          params = { accountNumber: "@accountNumber" };
        }
        var resource;
        resource = $resource(url, params, actions);
        // if (object === "Attachments") {
        //   resource = $cachedResource(cacheKey, url, params, actions);
        // }
        // }
        // Angular always calls POST on $save()
        // This hack is based on
        // http://kirkbushell.me/angular-js-using-ng-resource-in-a-more-restful-manner/
        resource.prototype.$save = function(success, error) {
          // Fortunately, LoopBack provides a convenient `upsert` method
          // that exactly fits our needs.
          var result = resource.upsert.call(this, {}, this, success, error);
          return result.$promise || result;
        };
        return resource;
      };
    });
  })
  .factory("authInterceptor", function($q, $location) {
    return {
      responseError: function(rejection) {
        if (rejection.status === 401) {
          if (
            $location.path() !== "/login" &&
            $location.path() !== "/wachtwoord" &&
            $location.path() !== "/registreren"
          ) {
            console.log("unauthorized path:" + $location.path());
            window.sessionStorage.setItem('nextAfterLogin', $location.url());
            $location.path("/login");
          }
        }
        return $q.reject(rejection);
      }
    };
  })
  .factory("bookkeeperInterceptor", function(
    $q,
    $location,
    LoopBackAuth,
    $rootScope
  ) {
    return {
      request: function(config) {
        // filter out non urlBase requests
        if (!config.url.includes(API_ENDPOINT)) {
          return config;
        }

        if ($rootScope.currentCompany) {
          if (config.url.indexOf("?") > -1) {
            config.url =
              config.url + "&currentCompanyId=" + $rootScope.currentCompany.id;
          } else {
            config.url =
              config.url + "?currentCompanyId=" + $rootScope.currentCompany.id;
          }
          return config || $q.when(config);
        }
        return config;
      }
    };
  })

  .run(function($rootScope, $stateParams, $state, $location, LoopBackAuth, Auth, User, $transitions, $timeout) {
    $transitions.onSuccess({ }, function(trans) {
      const state = trans.router.stateService.current;
      // console.log('transition ',state);

      // if(state.name.match('playground')) {
      //   return;
      // }
      $timeout(()=> {
        const popStateEvent = new PopStateEvent('popstate');
        dispatchEvent(popStateEvent);
    })
    });

    window.onpopstate = function(event) {
      // console.log(`location: ${document.location}, state: ${JSON.stringify(event.state)}`)
    }
    // To share with React code
    injectNgDeps({$rootScope, $stateParams, $state, LoopBackAuth, Auth, $location, $timeout});
    $rootScope.isActive = function(route) {
      var path = $location.path();
      return path.includes(route);
    };

    $rootScope.isActiveExact = function(route) {
      var path = $location.path();
      return path === route;
    };

    $rootScope.sendAnalytics = function(fromState) {
      var user = User.getCachedCurrent();

      if (!user) return;

      if (user.isBookkeeper) return;

      var company = $rootScope.currentCompany;
      if (!company) return;
      console.log('identify analtycis');
      analytics.identify(user.id, {
        name: user.name,
        email: user.email
      });

      var sCompany = {};
      company = JSON.parse(JSON.stringify(company));
      function endsWith(string, suffix) {
        return string.match(suffix + "$") == suffix;
      };

      for (var key in company) {
        if (company.hasOwnProperty(key)) {
          var value = company[key];
          if (key === "phone") key = "phone";
          if (key === "numberOfEmployees") key = "employees";
          if (endsWith(key,"Date")) {
            sCompany[key + "Formatted"] = moment(value).format("DD-MM-YYYY");
          }

          sCompany[key] = value;
        }
      }
      sCompany["avatar"] =
        "https://logo.accountingbox.nl/?website=" + company.website;
      if (company) {
        analytics.group(company.id, sCompany);
      }
      var path = $location.path();
      var querystring = "";
      var referrer = "";
      if (path.indexOf("?" !== -1)) {
        querystring = path.substring(path.indexOf("?"), path.length);
      }
      if (fromState && fromState.name) {
        referrer =
          $location.protocol() + "://" + $location.host() + "/" + fromState.url;
      }
      analytics.page({
        path: path,
        referrer: referrer,
        search: querystring,
        url: $location.absUrl()
      });
    };
    // $rootScope.previousState;
    // $rootScope.previousStateParams;
    // $rootScope.currentState;
    // $rootScope.currentStateParams;
    $rootScope.$on("$stateChangeSuccess", function(
      event,
      toState,
      toParams,
      fromState,
      fromParams
    ) {
      $rootScope.stateIsLoading = false;
      $rootScope.previousState = fromState.name;
      $rootScope.previousStateParams = fromParams;
      $rootScope.currentState = toState.name;
      $rootScope.currentStateParams = toParams;
      console.log('pusher $stateChangeSuccess fromState.name', fromState.name);
      console.log('pusher $stateChangeSuccess toState.name', toState.name);
      $rootScope.sendAnalytics(fromState);
      if (window.loading_screen) {
        window.loading_screen.finish();
      }
    });

    $transitions.onStart({ to: "app.**" }, function(trans) {
      if(window.nv) { //temp fix when resize lister is still active in dashboard grpah
        window.nv.charts = {};
        window.nv.graphs = [];
        window.nv.logs = {};
        // remove resize listeners
        window.onresize = null;
      }

      if (!User.isAuthenticated()) {
        // User isn't authenticated. Redirect to a new Target State
        window.sessionStorage.setItem('nextAfterLogin', $location.url());
        return trans.router.stateService.target("login");
      }
    });
  });
